import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {DataObjectAssignmentType} from "@cm/utils/data-object-assignment"

export const organizationName = "ultrafabrics" as const

const tileableRenderOptions: FilenameSchemaEntry["options"] = {
    imageFormatSpelling: {
        tiff: "tif",
        jpeg: "jpg",
    },
}

const mapsExportOptions: FilenameSchemaEntry["options"] = {
    imageFormatSpelling: {
        jpeg: "jpeg",
    },
}

export const schemas: FilenameSchemaEntry[] = [
    // maps exports
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "$MATERIAL_NAME$_$EXPORT_FORMAT$_$EXPORT_RESOLUTION$",
        options: mapsExportOptions,
    },

    // tileable renders
    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "$MATERIAL_NAME$ $WIDTH_CM$x$HEIGHT_CM$.$IMAGE_FORMAT$",
        options: tileableRenderOptions,
    },
]
